import { render, staticRenderFns } from "./dialog-save-menu.vue?vue&type=template&id=3f637e22&scoped=true&"
import script from "./dialog-save-menu.vue?vue&type=script&lang=js&"
export * from "./dialog-save-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f637e22",
  null
  
)

export default component.exports